<template>
  <div class="m-intro">
    <svg
      class="intro-icon"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 107.7 126"
    >
      <g>
        <path
          fill="#CFE6F0"
          d="M76.5 79.1C71.8 81.4 65 82.6 57 82.8c-8.2 0-15.1-1.4-19.6-3.7-5.3-2.7-7.6-6.7-5.7-11.7 1 2.7 2.9 2.9 5.7 4.9 4.7 3.1 11.5 4.7 19.6 4.9 8.2 0 15.1-1.8 19.6-4.9 2.7-1.8 4.7-2.2 5.7-4.9C84.2 72.4 81.8 76.5 76.5 79.1zM19.2 74.4v26.8c-.1 1.7-1.3 3.1-2.9 3.3L2 107.9V69.3l13.9 1.6C17.7 71 19.2 72.5 19.2 74.4z"
          transform="translate(0 8.543)"
        />
        <path
          fill="#4F5661"
          d="M51.7,117.5L51.7,117.5z"
          transform="translate(0 8.543)"
        />
        <path
          fill="#53C27C"
          d="M67.3,55.2c0-4.3-2.7-6.7-9-8c-5.3-1.2-5.9-2.3-5.9-3.7c0-1.8,1.8-2.9,4.1-2.9 c2.4,0,4.6,0.9,6.5,2.3l1,0.8l2.9-3.9L66.2,39c-1.9-1.7-4.3-2.7-6.9-3.1v-3.5c0-0.9-0.7-1.6-1.5-1.6c0,0,0,0,0,0h-1.6 c-0.9,0-1.6,0.7-1.6,1.5c0,0,0,0,0,0v3.5c-4.1,0.8-6.9,3.7-6.9,7.6c0,5.5,4.5,7.2,9.2,8.2c5.1,1.2,5.5,2.2,5.5,3.7 c0,1.8-1.8,3.1-4.3,3.1c-2.9,0-5.1-1-7.6-3.1l-0.8-0.8l-3.1,3.7l0.8,0.8c2.1,2,4.6,3.3,7.4,3.9v3.5c0,0.9,0.7,1.6,1.5,1.6 c0,0,0,0,0,0h1.6c0.9,0,1.6-0.7,1.6-1.5c0,0,0,0,0,0v-3.3C64.2,62.6,67.3,59.5,67.3,55.2z"
          transform="translate(0 8.543)"
        />
        <path
          fill="#4F5661"
          d="M50.5,21.5l-0.6,0.2C50.1,21.6,50.3,21.5,50.5,21.5z"
          transform="translate(0 8.543)"
        />
        <path
          fill="#CFE6F0"
          d="M66,22.3c-2.9,1.1-6.1,1.6-9.2,1.6c-3.1,0-6.3-0.5-9.2-1.6v-8.2c2.9,1.1,6.1,1.6,9.2,1.6 c3.1,0,6.3-0.5,9.2-1.6V22.3z"
          transform="translate(0 8.543)"
        />
        <g fill="#4F5661">
          <path
            d="M107.1,75.8l-1.4-2c-0.7-0.8-1.5-1.5-2.3-2.2l1.8-1c0.4-0.3,0.7-0.7,0.8-1.2 c0.1-0.5,0.1-1.1-0.2-1.6l-2-2.9c-3.3-4.3-9.2-5.5-13.9-2.9c-0.9,0.5-1.3,1.6-0.8,2.5c0.5,0.9,1.6,1.3,2.5,0.8c0,0,0,0,0,0 c3-1.7,6.8-0.9,9,1.8l0.8,1.2l-2.3,1.6c-2.4-0.4-4.8,0-6.9,1.2c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0L71.4,85.2 c-0.9,0.6-1.2,1.8-0.6,2.7c0.6,0.9,1.8,1.2,2.7,0.6L94,74.4c2.9-1.6,6.5-0.8,8.6,1.8l0.2,0.2L69.7,98.5c-0.2,0.2-0.6,0.2-0.8,0.4 c0.3-0.8,0.5-1.7,0.4-2.5c0-4.2-3.4-7.6-7.6-7.6H44.2c-1.1,0-2,0.9-2,2c-0.1,1,0.7,1.9,1.7,2c0.1,0,0.1,0,0.2,0h17.4 c2.2,0,3.9,1.8,3.9,3.9s-1.8,3.9-3.9,3.9l0,0H32.9c-4.7,0.1-9-2.3-11.5-6.3V81.2c0-3.2,2.6-5.9,5.9-5.9c1.1,0,2-0.9,2-2 c0.1-1-0.7-1.9-1.7-2c-0.1,0-0.1,0-0.2,0c-2.2,0-4.2,0.8-5.9,2.2c-0.5-2.4-2.6-4.2-5.1-4.3L2.3,67.7c-0.5,0-1.1,0.1-1.6,0.4 c-0.5,0.1-0.9,0.6-0.8,1.2v38.6c0,0.6,0.3,1.2,0.8,1.6c0.3,0.2,0.8,0.4,1.2,0.4h0.4l14.5-3.1c2.5-0.5,4.4-2.7,4.5-5.3v-1.6 c3.2,2.8,7.3,4.3,11.6,4.3h29.4c2.5,0,7.2-0.8,9.8-2.3l34.8-23.1c0.4-0.3,0.7-0.8,0.8-1.4C107.7,76.7,107.5,76.2,107.1,75.8z M17.4,101.2c0,0.8-0.6,1.4-1.4,1.6l-12.1,2.7V71.5l11.7,1.4c1,0.2,1.8,0.8,1.8,1.6V101.2z"
            transform="translate(0 8.543)"
          />
          <path
            d="M33.3,71.3c5.5,4.9,13.5,7.6,23.1,7.8h1c9.6-0.2,17.4-2.9,23.1-7.8c3.3-2.9,5.7-6.7,6.9-11 c1.6-5.7,1.2-12.1-1.4-19c-4.7-12.9-15.9-20.2-18-21.5v-5.7c0-2.5,3.5-8,5.7-11c0.4-0.6,0.5-1.3,0.2-2C73.5,0.5,72.8,0,72,0H41.7 c-0.7,0-1.4,0.4-1.8,1c-0.3,0.6-0.2,1.4,0.2,2c2.3,3.1,5.7,8.6,5.7,11v6.3c-4.1,2.5-13.9,9.6-18,20.6c-2.5,7-2.9,13.3-1.4,19 C27.5,64.1,29.9,68.2,33.3,71.3z M45.2,3.9h23.1c-1.6,2.5-3.5,6.1-4.1,8.8c-4.8,1.6-9.9,1.6-14.7,0C48.7,9.5,47.2,6.5,45.2,3.9z M64,16.8v4.1c-4.7,1.4-9.8,1.4-14.5,0v-4.1C54.3,18,59.3,18,64,16.8z M31.3,42.3c3.3-9.2,11.5-15.5,15.7-18.2 c3.1,1.2,6.4,1.8,9.8,1.8c3.3,0,6.7-0.6,9.8-1.8l0.8-0.2c3.5,2.5,11.4,8.8,14.9,18.4c2.2,6.3,2.7,11.7,1.4,16.6 c-1,3.5-3,6.7-5.7,9.2C73,72.4,65.6,74.8,57,75c-8.6,0-16.1-2.5-20.9-6.9c-2.8-2.4-4.8-5.6-5.7-9.2C28.8,54.2,29.2,48.5,31.3,42.3 z"
            transform="translate(0 8.543)"
          />
        </g>
        <g fill="#CFE6F0">
          <path
            d="M9.6.4l.7 1.8c.1.2.2.3.4.4l1.8.7c.4.1.5.5.4.9-.1.2-.2.3-.4.4l-1.8.7c-.2.1-.3.2-.4.4L9.6 7.6C9.5 7.9 9.1 8.1 8.8 8 8.6 7.9 8.4 7.7 8.4 7.6L7.7 5.7C7.6 5.5 7.5 5.4 7.3 5.3L5.4 4.6C5.1 4.5 4.9 4.1 5 3.8c.1-.2.2-.3.4-.4l1.8-.7c.2-.1.3-.2.4-.4l.7-1.8C8.4.1 8.8-.1 9.2 0 9.4.1 9.6.3 9.6.4zM5.2 15.5L6 17.6C6.1 17.8 6.2 18 6.4 18l2.1.8c.4.1.6.6.4.9 0 0 0 0 0 .1-.1.2-.2.4-.4.4L6.4 21C6.2 21.1 6 21.2 6 21.4l-.8 2.1c-.1.4-.6.6-.9.4 0 0 0 0-.1 0-.2-.1-.4-.2-.4-.4L3 21.4C2.9 21.2 2.8 21 2.6 21l-2.1-.8c-.4-.1-.6-.6-.4-.9 0 0 0 0 0-.1.1-.2.2-.4.4-.4L2.6 18C2.8 17.9 3 17.8 3 17.6l.8-2.1c.1-.4.6-.6.9-.4 0 0 0 0 .1 0C5 15.1 5.1 15.3 5.2 15.5z"
            transform="translate(84.647 .026)"
          />
        </g>
      </g>
    </svg>
    <div class="m-intro__title">Standard vs. Itemized</div>
    <h2>Which one are you eligible for?</h2>
    <p>
      Should I claim the standard deduction or itemize? That is a common
      question especially after Tax Reform. Under Tax Reform, the standard
      deduction amount increased and some itemized deductions went away, so
      close to 90% of taxpayers now take the standard deduction. To see how your
      numbers shake out, click on the button below.
    </p>
    <button class="m-btn m-btn--intro" @click="next">Start</button>
  </div>
</template>

<script>
export default {
  name: "Intro",
  methods: {
    next() {
      this.$store.commit("NEXT_PAGE");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/vars";
.m-intro {
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 60px;
  .intro-icon {
    width: 108px;
    height: 126px;
    margin-bottom: 12px;
  }
  p {
    color: $cGrayText;
    font-size: 16px;
    font-family: $fPrimary;
    font-weight: $fReg;
    line-height: 22px;
    text-align: center;
    max-width: 421px;
    margin-bottom: 30px;
  }
  h2 {
    font-family: $fPrimary;
    font-size: 32px;
    font-weight: $fMed;
    line-height: 38px;
    max-width: 343px;
    text-align: center;
    margin-bottom: 12px;
    color: $cDark;
  }
  &__title {
    font-family: $fPrimary;
    font-size: 24px;
    font-weight: $fBold;
    color: $cTeal;
    margin-bottom: 20px;
  }
}
</style>
